import { useState, useRef, useEffect } from "react";
import "../../css/HomeScreen/Sidebar.css";
import Logo from "../../assets/images/logo/Horizontal logo.png";
import { useNavigate, useLocation } from "react-router-dom";
import { auth } from "../../backend/firebaseConfig";
import LogoutButton from "./Buttons/LogoutButton";
import { signOut } from "firebase/auth";
import { ReactComponent as SmallLogo } from "../../assets/images/logo/logo-Ghost-White.svg";
import { ReactComponent as MenuIcon } from "../../assets/icons/Hamburger Button.svg";

const Sidebar = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(null);
  const [isOverlayVisible, setOverlayVisible] = useState(false);
  const overlayRef = useRef(null);
  const location = useLocation();

  const navigationItems = [
    {
      label: "Application Form",
      route: "/Application",
    },
  ];

  const handleItemClick = (item, index) => {
    setActiveIndex(index);
    navigate(item.route);

    // Automatically close the sidebar on small screens
    // if (window.innerWidth <= 839) {
    //   toggleSidebar();
    // }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (error) {
      // console.error("Error during logout:", error);
    }
  };

  const handleMenuClick = () => {
    setOverlayVisible(!isOverlayVisible);
  };

  const handleClickOutside = (event) => {
    if (
      isOverlayVisible &&
      overlayRef.current &&
      !overlayRef.current.contains(event.target)
    ) {
      setOverlayVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOverlayVisible]);
  const handleCloseClick = () => {
    setOverlayVisible(false);
  };
  return (
    <>
      {/* {!isSidebarOpen && (
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          <MenuIcon />
        </button>
      )}
      {isSidebarOpen && (
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          <CloseIcon />
        </button>
      )} */}
      <div className={`sidebar`}>
        <div className="sidebar-content">
          <img
            src={Logo}
            alt="Logo"
            className="sidebar-logo"
            onClick={() => {
              window.open("https://rosemountfs-ifa.co.uk/", "_blank");
            }}
          />
          {navigationItems.map((item, index) => (
            <div
              className={`sidebar-Tab ${
                location.pathname === item.route ? "active" : ""
              }`}
              key={index}
              onClick={() => handleItemClick(item, index)}
            >
              <div
                className={`sidebar-icon ${
                  location.pathname === item.route ? "active" : ""
                }`}
              ></div>

              <h4>{item.label}</h4>
            </div>
          ))}
          <div className="sidebar-footer">
            <div className="Content">{auth.currentUser?.displayName || ""}</div>
            <LogoutButton title="Logout" onClick={handleLogout} />
          </div>
        </div>
        <div className="responsive-sidebar-content">
          <div>
            <MenuIcon onClick={handleMenuClick} />
          </div>
          <div className="responsive-sidebar-logo">
            <SmallLogo />
          </div>
        </div>
      </div>

      {isOverlayVisible && (
        <div className="NavBar-Overlay">
          {/* <div className="Close-Button">
            <CloseIcon onClick={handleCloseClick} />
          </div> */}
          <div className="NavBar-Overlay-Content" ref={overlayRef}>
            {navigationItems.map((item, index) => (
              <div
                className={`sidebar-Tab `}
                key={index}
                onClick={() => handleItemClick(item, index)}
              >
                <div
                  className={`sidebar-icon ${
                    activeIndex === index ? "active" : ""
                  }`}
                >
                  {item.icn}
                </div>
                <div
                  className={`nav-item ${
                    activeIndex === index ? "active" : ""
                  }`}
                >
                  {item.label}
                </div>
              </div>
            ))}
            <div className="Content-Large">
              {auth.currentUser?.displayName || ""}
            </div>
            <LogoutButton title="Logout" onClick={handleLogout} />
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
